import React, { useState, useCallback } from 'react';
import { BarcodeScanner } from './BarcodeScanner';
import { ScanActionSheet } from './ScanActionSheet';
import { ScanNotFoundSheet } from './ScanNotFoundSheet';
import { scanAPI } from '../lib/api';
import { toast } from 'sonner';

export const ScanManager = ({ 
  open, 
  onClose, 
  context = 'warehouse',  // 'warehouse' | 'vehicle'
  vehicleId = null,
  onActionComplete
}) => {
  const [scannerOpen, setScannerOpen] = useState(true);
  const [actionSheetOpen, setActionSheetOpen] = useState(false);
  const [notFoundOpen, setNotFoundOpen] = useState(false);
  const [scanResult, setScanResult] = useState(null);
  const [scannedCode, setScannedCode] = useState('');
  const [loading, setLoading] = useState(false);

  const handleScan = useCallback(async (code) => {
    setScannedCode(code);
    setScannerOpen(false);
    setLoading(true);
    
    try {
      const res = await scanAPI.lookup(code);
      setScanResult(res.data);
      setActionSheetOpen(true);
    } catch (err) {
      if (err.response?.status === 404) {
        setNotFoundOpen(true);
      } else {
        toast.error('Failed to lookup code');
        onClose();
      }
    } finally {
      setLoading(false);
    }
  }, [onClose]);

  const handleActionSheetClose = useCallback(() => {
    setActionSheetOpen(false);
    setScanResult(null);
    onClose();
  }, [onClose]);

  const handleNotFoundClose = useCallback(() => {
    setNotFoundOpen(false);
    setScannedCode('');
    onClose();
  }, [onClose]);

  const handleCodeAssigned = useCallback(() => {
    // After assigning, try to scan again
    handleScan(scannedCode);
  }, [scannedCode, handleScan]);

  const handleScannerClose = useCallback(() => {
    setScannerOpen(false);
    onClose();
  }, [onClose]);

  if (!open) return null;

  return (
    <>
      <BarcodeScanner 
        open={open && scannerOpen}
        onClose={handleScannerClose}
        onScan={handleScan}
      />
      
      <ScanActionSheet 
        open={actionSheetOpen}
        onClose={handleActionSheetClose}
        scanResult={scanResult}
        context={context}
        vehicleId={vehicleId}
        onActionComplete={onActionComplete}
      />
      
      <ScanNotFoundSheet 
        open={notFoundOpen}
        onClose={handleNotFoundClose}
        scannedCode={scannedCode}
        onAssigned={handleCodeAssigned}
      />
    </>
  );
};

export default ScanManager;
